// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '302e9e0d-df71-4460-ba0e-5aebbdc46144',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 390,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          x: 'width * 0.5'
        }
      }
    },
    {
      id: '46f6fb07-a30d-498e-a1b8-ebd8aacad463',
      type: 'Container',
      name: '',
      className: '',
      x: -335,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '302e9e0d-df71-4460-ba0e-5aebbdc46144'
    },
    {
      id: 'fed0fffe-5a83-4356-a25a-9a220f8788ff',
      type: 'Container',
      name: '',
      className: '',
      x: 335,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '302e9e0d-df71-4460-ba0e-5aebbdc46144'
    },
    {
      id: '57fb67ad-c136-421c-8444-fc17a0a02a8a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 170,
      y: 16,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gameplay_progress',
      parent: '46f6fb07-a30d-498e-a1b8-ebd8aacad463'
    },
    {
      id: '306b34d6-6852-4de1-b201-9f9d476e857f',
      type: 'NineSlicePlane',
      name: 'playerProgressBar',
      className: '',
      x: 35,
      y: 25,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 1,
        y: 0
      },
      width: 274,
      height: 36,
      leftWidth: 12,
      topHeight: 12,
      rightWidth: 12,
      bottomHeight: 12,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gameplay_progress_barBlue',
      parent: '46f6fb07-a30d-498e-a1b8-ebd8aacad463',
      data: {
        minWidth: 14,
        maxWidth: 274
      }
    },
    {
      id: 'b4a5f6ed-4fa4-42d2-92f5-a6a9f12120f5',
      type: 'Text',
      name: 'playerProgress',
      className: '',
      x: 162,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '25%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5E0E0A',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '46f6fb07-a30d-498e-a1b8-ebd8aacad463'
    },
    {
      id: '6982fde1-d15b-4a00-8616-d50d269c3092',
      type: 'Sprite',
      name: 'playerAvatar',
      className: 'userAvatar_SPL',
      x: 0,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '46f6fb07-a30d-498e-a1b8-ebd8aacad463'
    },
    {
      id: 'e7b42d90-1d53-4c37-b827-75b3e38afa8c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Profile_Picture_Frame',
      parent: '46f6fb07-a30d-498e-a1b8-ebd8aacad463'
    },
    {
      id: '16809a49-1ab0-4c1e-ae64-6625e733e68e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -170,
      y: 16,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gameplay_progress',
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff'
    },
    {
      id: 'e0f8e071-acf7-4189-b762-f06a036d4d6a',
      type: 'NineSlicePlane',
      name: 'enemyProgressBar',
      className: '',
      x: -35,
      y: 25,
      scale: {
        x: -1,
        y: 1
      },
      pivot: {
        x: 1,
        y: 0
      },
      width: 274,
      height: 36,
      leftWidth: 12,
      topHeight: 12,
      rightWidth: 12,
      bottomHeight: 12,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gameplay_progress_barRed',
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff',
      data: {
        minWidth: 14,
        maxWidth: 274
      }
    },
    {
      id: 'c3583305-b8d4-4ffb-bcd6-9d8d9e781420',
      type: 'NineSlicePlane',
      name: 'enemyProgressBarOverlay',
      className: '',
      x: -35,
      y: 25,
      scale: {
        x: -1,
        y: 1
      },
      pivot: {
        x: 1,
        y: 0
      },
      width: 274,
      height: 36,
      leftWidth: 12,
      topHeight: 12,
      rightWidth: 12,
      bottomHeight: 12,
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_gameplay_progress_barRed_overlay',
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff',
      data: {
        minWidth: 14,
        maxWidth: 274
      }
    },
    {
      id: '1d4fb8ca-c14a-45d7-a5cc-6d57a4a7402c',
      type: 'Sprite',
      name: 'enemyAvatar',
      className: 'insertAvatar_SPL',
      x: 0,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff',
      data: {
        insertAvatar_SPL: 'versus.enemy'
      }
    },
    {
      id: 'a1ad532b-ee66-473a-9c66-1745207c847f',
      type: 'Text',
      name: 'enemyProgress',
      className: '',
      x: -162,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '25%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5E0E0A',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff'
    },
    {
      id: 'cd12847f-4309-43bd-96b6-ad263c9857e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Profile_Picture_Frame',
      parent: 'fed0fffe-5a83-4356-a25a-9a220f8788ff'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 760,
  version: '4.0.1',
  animations: [
    {
      id: 'ed3b3815-c3e4-43eb-86b2-f51beec42e9e',
      name: 'highlightEnemyProgress',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: '90a49dde-5755-4c07-8b20-18e45752b2d9',
          type: 'Setter',
          name: 'SET_enemyProgressBarOverlay',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'enemyProgressBarOverlay',
          disabled: false
        },
        {
          id: '748ed11e-7caf-49b3-a42a-50dbb59303cb',
          type: 'Tween',
          name: 'TWEEN_enemyProgressBarOverlay',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'enemyProgressBarOverlay',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '562247f6-e3d5-4757-96f8-354132715c41',
          type: 'Tween',
          name: 'TWEEN_enemyProgressBarOverlay_copy',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 300,
          sourceName: 'enemyProgressBarOverlay',
          easing: 'CubicIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class VersusTopBarLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  playerProgressBar!: NineSlicePlane & { data: typeof raw['list'][4]['data'] };
  playerProgress!: Text;
  playerAvatar!: Sprite;
  enemyProgressBar!: NineSlicePlane & { data: typeof raw['list'][9]['data'] };
  enemyProgressBarOverlay!: NineSlicePlane & { data: typeof raw['list'][10]['data'] };
  enemyAvatar!: Sprite & { data: typeof raw['list'][11]['data'] };
  enemyProgress!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] })[];
  userAvatar_SPL!: (Sprite)[];
  insertAvatar_SPL!: (Sprite & { data: typeof raw['list'][11]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class highlightEnemyProgress {
  Layout: {
    enemyProgressBarOverlay: object;
  };

  BlockTypeByName: {
    SET_enemyProgressBarOverlay: object;
    TWEEN_enemyProgressBarOverlay: object;
    TWEEN_enemyProgressBarOverlay_copy: object;
  };

  flowData = raw.animations[0];
}
